import React from 'react'
import { NoSubmissions } from '@LTIDashboard/modules/SubmissionsDashboard/Students'
import { Students } from '@LTIDashboard/modules/SubmissionsDashboard/Students'

export function StudentsController({ submissions }) {
  const OutputComponent = {
    subsFound: { Component: Students, props: { submissions } },
    noSubsFound: { Component: NoSubmissions, props: {} },
  }
  const { Component, props } =
    OutputComponent[submissions.length > 0 ? 'subsFound' : 'noSubsFound']

  return (
    <React.Fragment>
      <Component {...props} />
    </React.Fragment>
  )
}
